"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("core-js/modules/web.dom.iterable");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _videoViewer = _interopRequireDefault(require("@/directive/video-viewer"));
var _anchor = require("@/api/anchor");
// 工会初审主播
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default,
    VideoViewer: _videoViewer.default
  },
  filters: {
    statusFilter: function statusFilter(val) {
      if (val === 0) {
        val = 'waiting for review'; // 待审核
      } else if (val === 1) {
        // 复审通过
        val = 'adopt';
      } else if (val === 2) {
        val = 'Reject';
      } else if (val === 9) {
        // 工会初审通过(待复审)
        val = 'adopt';
      }
      return val;
    }
  },
  data: function data() {
    return {
      listLoading: false,
      audit: {},
      auditList: [],
      auditTotal: 0,
      auditListQuery: {
        page: 1,
        size: 10,
        status: 2
      }
    };
  },
  mounted: function mounted() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$anchorAuthList, code, data, video_arr;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _anchor.anchorAuthList)(this.auditListQuery);
            case 1:
              _yield$anchorAuthList = _context.v;
              code = _yield$anchorAuthList.code;
              data = _yield$anchorAuthList.data;
              this.listLoading = false;
              if (code === 0) {
                video_arr = [];
                data.list.forEach(function (item) {
                  var arr = {};
                  arr.video_see = false;
                  arr.key = item.video_url;
                  video_arr.push(arr);
                });
                this.auditList = data.list;
                this.auditTotal = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }()
  }
};